/*
 * The matched characters of a searched title. Kept to a tint and a weight
 * rather than the browser's yellow, so it reads as part of the row's text and
 * stays legible on the coloured capability rows.
 */
.mark {
  padding-inline: 1px;
  margin-inline: -1px;

  font-weight: var(--weight-strong);

  color: inherit;
  background-color: var(--accent-soft);
  border-radius: 2px;
}
